import Vue from "vue";
import Vuex from "vuex";
// import 'es6-promise/auto';
import layout from './modules/layout'
import menu from './modules/menu'
import chat from './modules/chat'
import products from './modules/products'
import email from './modules/email'
import todo from './modules/todo'
import firebase_user from './modules/firebase_user'
import firebase_iaplog from './modules/firebase_iaplog'
import firebase_notice from './modules/firebase_notice'
import firebase_email from './modules/firebase_email'
import firebase_todo from './modules/firebase_todo'
import firebase_gift from './modules/firebase_gift'
import firebase_item from './modules/firebase_item'
import firebase_rank from './modules/firebase_rank'
//import jobs from './modules/jobs'
import courses from './modules/courses'
import common from './modules/common'
import { alert } from './modules/alert'
import { authentication } from './modules/authentication'
import { users } from './modules/users'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
    },
    mutations: {
      changeLang (state, payload) {
        localStorage.setItem('currentLanguage', payload.id)
        localStorage.setItem('currentLanguageIcon', payload.icon)
        window.location.reload();
      }
    },
    actions: {
      setLang ({ commit }, payload) {
        commit('changeLang', payload)
      }
    },
    modules: {
      alert,
      authentication,
      users,
      layout,
      chat,
      menu,
      products,
      email,
      todo,      
      firebase_user,
      firebase_iaplog,
      firebase_notice,
      firebase_email,
      firebase_gift,
      firebase_item,
      firebase_rank,
      firebase_todo,
      //jobs,
      courses,
      common
    }
});

